<template>
    <div>
        <el-row class="mrt20">
            <el-col :span="5">
                <div class="grid-content bg-purple taskList">
                    <process-list ref="processList" :processlist="processlist" @swichComdata="swichComdata"></process-list>

                </div>
            </el-col>
            <el-col :span="19">
                <div class="grid-content bg-purple-light tabsList">
                    <tabs-list ref="tabsList" :tabslist="tabslist" ></tabs-list>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    // import * as API from "./api"
    import TabsList from "./components/TabsList";
    import ProcessList from "./components/ProcessList";
    export default {
        name: "entrust.vue",
        components: {TabsList,ProcessList},
        data() {
            return {
                tabslist:{},
                processlist:{},
            }
        },
        mounted() {

        },
        methods: {

            //传递加工公司数据
            swichComdata(row){
                this.tabslist=row;
                // console.log(row,111)
                // console.log(this.tabslist,"拿到子组件公司数据");
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mrt20{
        margin-top: 20px;
    }
</style>